<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-file-invoice-dollar" /> Contas a Receber
        </h2>
        <small class="text-muted">Gerencie suas Contas a Receber.</small>
      </div>

      <div class="col-md-6 text-right">
        <div>
          <!-- <button class="btn btn-success" style="margin-left: 5px" @click="storeBillReceive(searchForm.account_id)">
          <i class="fas fa-plus" />
          <span class="d-none d-md-inline"> Nova Conta a Receber</span>
        </button> -->

          <b-dropdown
            v-if="this.$acl.can('billReceiveCreateEdit')"
            class="ml-2"
            variant="success"
            right
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <i class="fas fa-plus" />
              <span class="d-none d-md-inline"> Novo</span>
            </template>

            <b-dropdown-item @click="storeBillReceive(searchForm.account_id)">
              <i class="fas fa-file-invoice"></i> Nova Conta a Receber
            </b-dropdown-item>
            <b-dropdown-item @click="handleNewBillCredit()">
              <i class="fas fa-dollar-sign"></i> Novo crédito
            </b-dropdown-item>
          </b-dropdown>

          <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
            <b-dropdown-item @click="openBillReceivebleReport()"
              ><i class="fas fa-print mr-2"></i>Imprimir Relatório
            </b-dropdown-item>
            <b-dropdown-item @click="openBillReceivebleSimplifiedReport()"
              ><i class="fas fa-print mr-2"/>Extrato de Débitos
            </b-dropdown-item>
            <template v-if="canManagerSettings">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="openBillReceivebleSettingsForm"
                ><i class="fas fa-cog mr-2" />Configurações de
                Crediário</b-dropdown-item
              >
            </template>
          </b-dropdown>
    
        </div>
      </div>
    </div>
    <br />
    <collapse-of-the-bill-receiveble-filter
      ref="CollapseOfTheBillReceivebleFilter"
      v-model="searchForm"
      @filter="select($event)"
    />
    <br />
    <div class="d-none d-md-block">
      <bill-receiveble-stats-card />
    </div>

    <b-row>
      <b-col cols="12" md="12">
        <table-paginator :data="bills" @pagechange="select($event)">
          <div class="row grid-table-heading d-md-flex d-none">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <div class="row">
                <div class="col text-right">Total de Compras</div>
                <div class="col text-right">Saldo Devedor</div>
                <div class="col text-right">Vencimento</div>
              </div>
            </div>
          </div>
          <hr />

          <template v-for="row in bills.data">
            <div
              class="row grid-table-row align-items-md-center align-items-start"
              :key="row.id"
              @click="openPersonBillReceiveForm(row)"
            >
              <!-- first column  -->
              <div class="col-6 col-md-6 d-flex">
                <div class="ml-2">
                  <avatar
                    inline
                    color="#fff"
                    :size="30"
                    :username="row.name"
                    :initials="row.name.slice(0, 1)"
                  ></avatar>
                  <span style="margin-left: 10px">{{ row.name }}</span>
                  <small class="text-muted" v-if="row.person_code">
                    #{{ row.person_code }}</small
                  >
                  <i
                    v-if="!row.can_buy_in_payment_method_5"
                    class="fas fa-lg fa-exclamation-circle text-danger ml-2"
                    title="Bloqueado para compras no crediário"
                  ></i>
                  <a
                    class="btn btn-link text-success"
                    @click.stop
                    :href="getWhatsAppLink(row)"
                    target="_blank"
                  >
                    <i class="fab fa-lg fa-whatsapp"></i>
                  </a>
                  <small class="text-muted" v-if="row.count > 1">
                    {{ row.count }} contas</small
                  >
                  <small class="text-muted" v-else>
                    {{ row.count }} conta</small
                  >
                  <br />
                </div>
              </div>

              <!-- second column -->
              <div class="col-6 col-md-6">
                <div class="row">
                  <div class="col text-right">
                    {{ row.total | decimal }}
                  </div>
                  <div class="col text-right">
                    <b>{{ row.total_receiveble | decimal }}</b>
                  </div>
                  <div class="col text-right">
                    <due-date-badge ref="DueDateBadge" :date="row.due_date" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </table-paginator>
      </b-col>
    </b-row>

    <error-handler :error="error" />

    <bill-receive-form ref="billReceive" @stored="select" />
    <receive-bill-receive-form ref="receiveBillReceiveForm" />
    <bill-receiveble-cancel-form ref="billReceivebleCancelForm" />
    <bill-payment-list ref="billPaymentList" />
    <person-bill-receive-form ref="personBillReceiveForm" @update="select" />
    <bill-receiveble-settings-form ref="billReceivebleSettingsForm" />
    <bill-receiveble-credit-form
      ref="billReceivebleCreditForm"
      @store="select"
    />
  </div>
</template>

<script>
import Filters from "./../mixins/Filters.js";
import moment from "moment";
import Avatar from "vue-avatar";
import BillReceiveForm from "../components/billReceiveble/forms/BillReceiveForm.vue";

import ReceiveBillReceiveForm from "../components/billReceiveble/forms/ReceiveBillReceiveForm";

import TablePaginator from "./../components/sections/TablePaginator.vue";
import BillReceivebleCancelForm from "../components/billReceiveble/forms/BillReceivebleCancelForm";
import BillPaymentList from "../components//billReceiveble/lists/BillPaymentList";

import PersonBillReceiveForm from "../components/billReceiveble/forms/PersonBillReceiveForm";

import FilterButton from "./../components/ui/FilterButton";
import BillReceivebleSettingsForm from "../components/billReceiveble/forms/BillReceivebleSettingsForm";
import BillReceivebleCreditForm from "../components/billReceiveble/forms/BillReceivebleCreditForm";
import CollapseOfTheBillReceivebleFilter from "../components/billReceiveble/filter/CollapseOfTheBillReceivebleFilter";
import DueDateBadge from "../components/ui/DueDateBadge";
import BillReceivebleStatsCard from "../components/billReceiveble/sections/BillReceivebleStatsCard";

export default {
  components: {
    TablePaginator,
    BillReceiveForm,
    Avatar,
    ReceiveBillReceiveForm,
    BillReceivebleCancelForm,
    BillPaymentList,
    PersonBillReceiveForm,
    FilterButton,
    BillReceivebleSettingsForm,
    BillReceivebleCreditForm,
    CollapseOfTheBillReceivebleFilter,
    DueDateBadge,
    BillReceivebleStatsCard,
  },

  data: function () {
    return {
      selected: [],

      person_id: {},

      name: {},

      bills: [],

      totalBillReceiveble: {},

      totalOverDue: {},

      billsDetails: [],

      dueByPeriod: {},

      billByPeriod: {},

      details: {
        value: 0,
      },

      searchForm: {
        name: null,
        due_date_start: null,
        due_date_end: null,
        status: ["o"],
      },

      status: {
        o: {
          text: "Aberto",
          class: "badge-primary",
        },

        p: {
          text: "Pago",
          class: "badge-success",
        },

        c: {
          text: "Cancelado",
          class: "badge-danger",
        },

        r: {
          text: "Renegociado",
          class: "badge-warning",
        },
      },

      now: {
        value: moment().format("YYYY/MM/DD"),
      },

      error: null,
    };
  },

  created() {
    this.$store.commit("pageHasLoaded");
    this.select();
    this.getStatsCardBillReceiveble();
  },

  computed: {
    hasSelected() {
      return this.selected.length > 0;
    },

    selectedCount() {
      return this.selected.length;
    },

    selectedValueSum() {
      var sum = 0;

      for (let index in this.selected) {
        sum += parseFloat(this.selected[index].value);
      }

      return Math.round(sum * 100) / 100;
    },

    selectedBalanceDueSum() {
      var sum = 0;

      for (let index in this.selected) {
        sum +=
          parseFloat(this.selected[index].value) -
          parseFloat(this.selected[index].received_value);
      }

      return Math.round(sum * 100) / 100;
    },

    canManagerSettings() {
      if (!this.$store.state.user) {
        return false;
      }

      if (
        this.$store.state.user.is_master_user != 1 &&
        this.$store.state.user.is_admin_user != 1
      ) {
        return false;
      }

      return true;
    },
  },

  methods: {
    storeBillReceive() {
      this.$refs.billReceive.open();
    },

    openPersonBillReceiveForm(person_id) {
      this.$refs.personBillReceiveForm.open(person_id);
    },

    isOverDue(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").isBefore(
        moment().subtract(1, "days")
      );
    },

    openBillReceiveCancelForm(bills) {
      this.$refs.billReceivebleCancelForm.open(bills);
    },

    openBillReceivebleSettingsForm() {
      this.$refs.billReceivebleSettingsForm.open();
    },

    refresh() {
      this.selected = [];
      // todo select current page
      this.select();
    },

    async getStatsCardBillReceiveble() {
      await this.$store.dispatch(
        "billreceiveble/getStatsCardBillsReceiveble",
        this.searchForm
      );
    },

    select(page = 1) {
      this.$store.commit("showLoading");
      this.searchForm.page = page;
      this.$store
        .dispatch("billreceiveble/getBillsReceiveble", this.searchForm)
        .then((response) => {
          this.bills = response.data.bill;

          this.totalBillReceiveble = response.data.billReceivebleSum;

          this.totalOverDue = response.data.overDueBillReceiveble;

          this.billsDetails = response.data.billDetails;

          this.getStatsCardBillReceiveble()

          this.$store.commit("hideLoading");
        })

        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    getDueDateBadge(date, status) {
      if (this.isOverDue(date) && status == "o") {
        return "badge-danger";
      }
      return "badge-primary";
    },

    // getWhatsAppLink(bills) {
    //   //   console.log(bills)
    //   let name = bills.name.replace(/ .*/, "");
    //   let link = "https://api.whatsapp.com/send?phone=+55" + bills.phone_wa;
    //   let msg =
    //     "&text=Olá " +
    //     name +
    //     ", temos um valor em aberto referente a " +
    //     "sua última compra com a loja " +
    //     this.$store.state.company.alias +
    //     ". Aguardamos você para novas compras!";

    //   return link + msg;
    // },

    printBillReceiveble(bills) {
      window.open("/contasareceber/imprimir-recibo/" + bills.id, "_blank");
    },

    getWhatsAppLink(bills) {
      let name = bills.name.replace(/ .*/, "");
      let link = "https://api.whatsapp.com/send?phone=+55" + bills.phone_wa;
      let msg =
        "&text=Olá " +
        name +
        ", temos um valor em aberto referente a" +
        "sua última compra com a loja " +
        this.$store.state.company.alias +
        " Aguardamos você para novas compras e tomar  cafézinho delicioso com a gente.!";

      return link + msg;
    },

    handleNewBillCredit() {
      this.$refs.billReceivebleCreditForm.open();
    },

    openBillReceivebleReport() {
      window.open("/contasareceber/relatorio");
    },
    openBillReceivebleSimplifiedReport() {
      window.open("/contasareceber/extrato-debito");
    },
  },
};
</script>

<style>
.col-md-1v2 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 12.499999999%;
  flex: 0 0 12.499999999%;
  max-width: 12.49;
}

table {
  width: 600px;
  border-collapse: collapse;
}

td {
  border-color: #ffffff;
  background-color: #ffffff;
  border-style: none;
  border-bottom-width: 0px;
  border-top-width: 0;
  border-right-width: 0;
  border-left-width: 0;
}
</style>
